export default __webpack_public_path__ + "img/img_audrey_ong-cd507bbb1e026553bae7a64a11354e36.jpg";